<ff-alerts></ff-alerts>
<navigation-spinner></navigation-spinner>
<modal-overlay></modal-overlay>
<offline-notification></offline-notification>
<software-update-notification></software-update-notification>
<satisfaction-survey [enabled]="false"></satisfaction-survey>
<router-outlet></router-outlet>
